const categoryIcons: Record<string, string> = {
  Lobby: 'lobby',
  Slots: 'slots',
  'Live Casino': 'liveCasino',
  'Game Shows': 'gameShows',
  'Crash Games': 'crashGames',
  'Lottery Games': 'lottery',
  'Virtual Games': 'virtualGames',
  'Virtual Sports': 'virtualGames',
  'Table Games': 'tableGames',
  Roulette: 'roulette',
  Blackjack: 'blackjack',
  Baccarat: 'baccarat',
  'Jackpot Games': 'jackpotGames',
  'Poker (RNG)': 'pokerRng',
  'Dice / Sic Bo': 'diceSicBo',
  Craps: 'craps',
  'Instant Win': 'instantWin',
  'Top Games': 'topGames',
  'New Releases': 'newRelease',
  'Mini Games': 'miniGames',
  'Popular Games': 'popularGames',
  'Live Roulette': 'liveRoulette',
  'Trending Now': 'trendingNow',
  'Live Blackjack': 'liveBlackjack',
  'VIP Tables': 'vipTables',
  'Live Baccarat': 'liveBaccarat',
  'High Roller Games': 'highRollerGames',
  'Live Poker': 'livePoker',
  'Buy Bonus Slots': 'buyBonusSlots',
  Megaways: 'megaways',
  'Megaways Slots': 'megawaysSlots',
  'Money Wheel': 'moneyWheel',
  'Andar Bahar / Teen Patti': 'andarBaharTeenPatti',
  'Classic Slots / Fruit Slots': 'classicSlots',
  'Branded Games': 'brandedGames',
};

export const getCasinoCategoryIcon = (label: string): string => {
  return categoryIcons[label] || 'generic';
};
